"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLinkExtension = void 0;
const remirror_1 = require("remirror");
const core_1 = require("@remirror/core");
const common_1 = require("./common");
const CommandsExtension_1 = require("../CommandsExtension/CommandsExtension");
const Extensions_1 = require("../Extensions");
let AssetLinkExtension = class AssetLinkExtension extends core_1.MarkExtension {
    get name() {
        return Extensions_1.MarkName.AssetLink;
    }
    createMarkSpec(extra, override) {
        return {
            inclusive: false,
            excludes: [this.name, Extensions_1.MarkName.Link].join(' '),
            ...override,
            attrs: {
                ...extra.defaults(),
                matrixAssetId: {},
                matrixIdentifier: {},
                href: { default: '' },
                matrixDomain: { default: this.options.matrixDomain },
                target: { default: this.options.defaultTarget },
            },
            parseDOM: [
                {
                    tag: 'a[data-matrix-asset-id]',
                    getAttrs: (node) => {
                        if (!(0, remirror_1.isElementDomNode)(node)) {
                            return false;
                        }
                        const matrixAssetId = node.getAttribute('data-matrix-asset-id');
                        const matrixIdentifier = node.getAttribute('data-matrix-identifier');
                        const matrixDomain = node.getAttribute('data-matrix-domain');
                        if (!matrixAssetId || !matrixIdentifier || !matrixDomain) {
                            return false;
                        }
                        return {
                            ...extra.parse(node),
                            matrixAssetId,
                            matrixIdentifier,
                            matrixDomain,
                            target: (0, common_1.validateTarget)(node.getAttribute('target'), this.options.supportedTargets, this.options.defaultTarget),
                        };
                    },
                },
            ],
            toDOM: (node) => {
                const { matrixAssetId, matrixIdentifier, matrixDomain, target, href, ...rest } = (0, core_1.omitExtraAttributes)(node.attrs, extra);
                const rel = 'noopener noreferrer nofollow';
                const attrs = {
                    ...extra.dom(node),
                    ...rest,
                    rel,
                    href,
                    target: (0, common_1.validateTarget)(target, this.options.supportedTargets, this.options.defaultTarget),
                    'data-matrix-asset-id': matrixAssetId,
                    'data-matrix-identifier': matrixIdentifier,
                    'data-matrix-domain': matrixDomain,
                };
                return ['a', attrs, 0];
            },
        };
    }
    updateAssetLink({ text, attrs, range }) {
        return this.store.getExtension(CommandsExtension_1.CommandsExtension).updateMark({
            attrs: { ...attrs, href: attrs.url },
            text,
            range,
            mark: this.type,
            removeMark: !attrs.matrixAssetId,
        });
    }
    removeAssetLink() {
        return (0, core_1.removeMark)({ type: this.type });
    }
};
__decorate([
    (0, core_1.command)()
], AssetLinkExtension.prototype, "updateAssetLink", null);
__decorate([
    (0, core_1.command)()
], AssetLinkExtension.prototype, "removeAssetLink", null);
AssetLinkExtension = __decorate([
    (0, core_1.extension)({
        defaultOptions: {
            matrixDomain: '',
            defaultTarget: common_1.LinkTarget.Self,
            supportedTargets: [common_1.LinkTarget.Self, common_1.LinkTarget.Blank],
        },
        defaultPriority: remirror_1.ExtensionPriority.High,
    })
], AssetLinkExtension);
exports.AssetLinkExtension = AssetLinkExtension;
